import { AppsService, SnackBarService } from 'app/services';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { first, mergeMap, takeUntil } from 'rxjs/operators';

import { AppsDialogComponent } from '../apps-dialog/apps-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { SnackbarType } from 'app/constants/Enums';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-apps-details',
  templateUrl: './apps-details.component.html',
  styleUrls: ['./apps-details.component.scss'],
})
export class AppsDetailsComponent implements OnInit, OnDestroy {
  customRoles: any[];
  roles: any[];
  inputValue;
  @Input() app;
  @Input() isInternal: boolean;
  private onDestroy$ = new Subject<void>();
  constructor(
    private _snackbarService: SnackBarService,
    private appsServ: AppsService,
    public dialogRef: MatDialogRef<AppsDialogComponent>,
    private _translateService: TranslateService
  ) {
    this.roles = [
      { name: 'AppManager', isSelected: true },
      { name: 'User', isSelected: false },
    ];
  }
  roleSelect(role) {
    role.isSelected = !role.isSelected;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }

  getValue(event) {
    this.inputValue = event;
  }

  input(event) {
    if (this.inputValue) {
      if (this.customRoles) {
        if (
          this.customRoles.filter((e) => e.name === this.inputValue).length <= 0
        ) {
          this.customRoles.push({ name: this.inputValue });
        }
      } else {
        this.customRoles = [];
        this.customRoles.push({ name: this.inputValue });
      }
      this.inputValue = '';
    }
  }

  removeRole(role) {
    this.customRoles = this.customRoles.filter((e) => e.name !== role.name);
  }

  saveData() {
    let selectedRoles = [];
    if (this.customRoles) {
      selectedRoles = JSON.parse(JSON.stringify(this.customRoles));
    }
    const internal = this.isInternal;
    this.roles.forEach((role) => {
      if (role.isSelected) {
        selectedRoles.push({ name: role.name });
      }
    });
    const payload = {
      roleViewModelList: selectedRoles,
      internalOnly: internal,
    };
    this.postRoles(payload, this.app.clientId);
  }

  postRoles(payload, id) {
    this.appsServ
      .createApps(this.app.clientId)
      .pipe(
        first(),
        mergeMap((res) => this.appsServ.postRoles(payload, this.app.clientId))
      )
      .subscribe(
        (data) => {
          let successMsg = '';
          let successTxt ='';
          this.customRoles = [];
          this.appsServ.getApps();
          this.close();
          this._translateService
            .get('roles_added_sucessfully')
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((value) => (successMsg = value));
          this._translateService
            .get('SNACKBAR.success')
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(value => (successTxt = value));
          this._snackbarService.showSnackbar(
            SnackbarType.success,
            successTxt,
            successMsg
          );
        },
        (error) => {}
      );
  }
}
